import { render, staticRenderFns } from "./FacilityDashboard.vue?vue&type=template&id=0d6591e9&scoped=true"
import script from "./FacilityDashboard.vue?vue&type=script&lang=js"
export * from "./FacilityDashboard.vue?vue&type=script&lang=js"
import style0 from "./FacilityDashboard.vue?vue&type=style&index=0&id=0d6591e9&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6591e9",
  null
  
)

export default component.exports